// extracted by mini-css-extract-plugin
module.exports = {"tancarFlotant":"videoBase_tancarFlotant__Rwv8o","show":"videoBase_show__cbh2n","botoTancar":"videoBase_botoTancar__Fasdz"};